import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import {
  ErrorSnacktOpen
} from "../../ErrorSnack/actions";
import { SetSolicitudesEnCurso } from "../FiltroBusquedaPQ/actions";
import { PermiteReplicarSolicitud } from "../ReplicarSolicitud/actions";



export const CargarPrestacionSolicitud = (prestacionSolicitud) => ({
  type: "CARGAR_PRESTACION_SOLICTUD",
  prestacionSolicitud,
});

export const OpenQuitarPrestacionSolicitud = (modalAction, guidFilaQuitar) => ({
  type: "OPEN_QUITAR_PRESTACION_SOLICITUD",
  modalAction,
  guidFilaQuitar,
});

export const OpenModalEliminarBorrador = (modalAction) => ({
  type: "OPEN_ELIMINAR_BORRADOR",
  modalAction,
});

export const LimpiarSolicitud = () => ({
  type: "LIMPIAR_SOLICITUD",
});

export const QuitarPrestacionSolicitudSeleccionada = () => ({
  type: "QUITAR_PRESTACION_SOLICITUD_SELECCIONADA",
});

export const GuardarSolicitudEditarCreacion = (detallePrestacion) => ({
  type: "GUARDAR_SOLICITUD_EDITAR_CREACION",
  detallePrestacion,
});

export const GuardarSolicitudEditarEliminacion = (detallePrestacion) => ({
  type: "GUARDAR_SOLICITUD_EDITAR_ELIMINACION",
  detallePrestacion,
});

export const GuardarSolicitudEditarModificacion = (detallePrestacion) => ({
  type: "GUARDAR_SOLICITUD_EDITAR_MODIFICACION",
  detallePrestacion,
});

export const CargarBorrador = (detalleBorrador) => ({
  type: "CARGAR_BORRADOR",
  detalleBorrador,
});

export const GuardarEstadoSolicitud = (Solicitud) => ({
  type: "GUARDAR_ESTADO_SOLICITUD",
  Solicitud,
});

export const OpenSolicitudEnviada = (modalAction) => ({
  type: "OPEN_SOLICITUD_ENVIADA",
  modalAction,
});

export const UpdateIdSolicitud = (idSolicitud, cargandoBorrador) => ({
  type: "UPDATE_ID_SOLICITUD",
  idSolicitud,
  cargandoBorrador,
});

export const UpdateStatusBorrador = (cargandoBorrador) => ({
  type: "UPDATE_STATUS_BORRADOR",
  cargandoBorrador,
});

export const UpdateIdSolicituAndPrestaciones = (IdSolicitud, prestaciones) => ({
  type: "UPDATE_ID_DETALLE_PRESTACION_PRESTACIONES",
  IdSolicitud,
  prestaciones
});

export const CargarDetalleSolicitud = (prestacionesSolicitud, idSolicitud) => ({
  type: "CARGAR_DETALLE_SOLICITUD_FIL",
  prestacionesSolicitud,
  idSolicitud,
});

export const UpdateIdAfterSaveBorradorByFirstTime = idSolicitud => ({
  type: "UPDATE_ID_SOLICITUD_SAVE_FIRST_TIME_BORRADOR",
  idSolicitud,
});

export const PrestacionesToHomologador = prestacionesToHomologador => ({
  type: 'PRESTACIONES_TO_HOMOLOGADOR',
  prestacionesToHomologador,
});

export const IdSolicitudForHomologador = IdSolicitudForHomologador => ({
  type: 'ID_SOLICITUD_FOR_HOMOLOGADOR',
  IdSolicitudForHomologador,
});

export const IdSolicitudHom = (IdSolicitudHomologador) => ({
  type: 'ID_SOLICITUD_HOMOLOGADOR',
  IdSolicitudHomologador,
});

export const nuevaSolicitud = (cantidad) => ({
  type: 'CREANDO_SOLICITUD',
  cantidad,
});

export const prestacionesHomologadas = prestacionesHomologadas => ({
  type: 'PRESTACIONES_HOMOLOGADAS',
  prestacionesHomologadas,
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const AddPrestacionSolicitud = (prestacionSolicitud) => (dispatch) => {
  dispatch(CargarPrestacionSolicitud(prestacionSolicitud));
};

export const GuardarSolicitud = (detalleSolicitud) => (dispatch) => {
  const params = {
    IdPrestacion: 0,
    Isapre: 0,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/detalle/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("GuardarSolicitud", result);
    // /dispatch(CargarDetallePrestacion(result));
    // dispatch(callback());
  }), (error) => {
    trace.error("GuardarSolicitud", error);
    // dispatch(errorObtenerDetallePrestacionEdicion(error));
  });
};

export const GuardarSolicitudParametrizada = (rutPrestador, PrutInstitucion, Isapre, IdEstadoSolicitud, IdTipoModificacionSolicitud, IdEstadoAreaProceso, IdEstadoSolicitudWF, observaciones, listaUsuarios, next) => (dispatch) => {
  const globalState = store.getState().global;
  const obs = observaciones.substring(0, 1000);
  const params = {
    RutPrestador: rutPrestador,
    RutInstitucion: PrutInstitucion,
    Isapre,
    IdEstadoSolicitud,
    IdTipoModificacionSolicitud,
    IdEstadoAreaProceso,
    IdEstadoSolicitudWF,
    observaciones: obs,
    token: globalState.token,
    ListaUsuarios: globalState.listaUsuariosConvenio,
    usuarioMail: globalState.datosUsuario.mail,
    usuarioNombre: globalState.datosUsuario.nombre,
    RutUsuario: globalState.rutUsuario,
    IdSolicitudHomologador: null,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushSolicitudParametrizada/`, {
    method: "POST",
    headers: {},
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("GuardarSolicitudParametrizada", result);
    dispatch(GuardarEstadoSolicitud(result));

    if (typeof next != "undefined") {
      next(result[0].IdSolicitud);
    }
  }), (error) => {
    trace.error("GuardarSolicitud", error);
  });
};

export const getBorrador = (rutPrestador, PrutInstitucion, Isapre, next) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    rutPrest: rutPrestador,
    rutInstitucion: PrutInstitucion,
    idTipoModificacionSolicitud: 11, // Actualizar Arancel
    isapre: Isapre,
    token: globalState.token,
    RutUsuario: globalState.rutUsuario,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/borrador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("getBorrador", result);
    //console.log("RESULT FROM SAVING BORRADOR:", result);
    dispatch(CargarBorrador(result));
    dispatch(UpdateIdAfterSaveBorradorByFirstTime(result[0].IdSolicitud));
    next(result[0].IdSolicitud);
  }), (error) => {
    trace.error("getBorrador", error);
  });
};

export const pushDetallePaquete = (detalleSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    detalleSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/pushDetallePaquete/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log(response)
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("pushDetalleSolicitud", json);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("pushDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al guardar el detalle de la solicitud:",
        error,
      ));
    });
};

export const pushDetalleCaracteristicas = (detalleSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    detalleSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/pushDetalleCaracteristicas/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log(response)
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("pushDetalleCaracteristicas", json);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("pushDetalleCaracteristicas", error);
      dispatch(ErrorSnacktOpen(
        "Error al guardar el detalle de las caracteristicas del paquete:",
        error,
      ));
    });
};

export const pushDetallePrestaciones = (detalleSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    detalleSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/pushDetallePrestaciones/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log(response)
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("pushDetallePrestaciones", json);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("pushDetallePrestaciones", error);
      dispatch(ErrorSnacktOpen(
        "Error al guardar el detalle de la prestacion del paquete:",
        error,
      ));
    });
};

export const updateSolicitud = (pidSolicitud, pidEstadoSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    idSolicitud: pidSolicitud,
    idEstadoSolicitud: pidEstadoSolicitud,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/updateSolicitud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("updateSolicitud", result);
    // dispatch(CargarBorrador(result));
    // dispatch(callback());
  }), (error) => {
    trace.error("updateSolicitud", error);
    dispatch(ErrorSnacktOpen(
      "Error al actualizar la solicitud:",
      error,
    ));
  });
};

export const deletePrestacionesBorrador = (pidSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    idSolicitud: pidSolicitud,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/deletePrestacionesBorrador/`, {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("updateSolicitud", result);
  }), (error) => {
    trace.error("updateSolicitud", error);
    dispatch(ErrorSnacktOpen(
      "Error al eliminar prestaciones del borrador:",
      error,
    ));
  });
};

export async function updateSolicitudsync(pidSolicitud, pidEstadoSolicitud, plistaUsuarios, pIdTipoModificacionSolicitud, pIdEstadoAreaProceso, pIdEstadoSolicitudWF) {
  const globalState = store.getState().global;
  const params = {
    idSolicitud: pidSolicitud,
    idEstadoSolicitud: pidEstadoSolicitud,
    listaUsuarios: plistaUsuarios,
    IdTipoModificacionSolicitud: pIdTipoModificacionSolicitud,
    IdEstadoAreaProceso: pIdEstadoAreaProceso,
    IdEstadoSolicitudWF: pIdEstadoSolicitudWF,
    token: globalState.token,
  };
  await fetch(`${apiConfig.apiUri}/v1/solicitudes/updateSolicitud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("updateSolicitud", result);
    // dispatch(CargarBorrador(result));
    // dispatch(callback());
  }), (error) => {
    trace.error("updateSolicitud", error);
    /* dispatch(ErrorSnacktOpen(
      "Error al actualizar la solicitud:",
      error.message === "Failed to fetch" ? "No se encontro método API" : error
    )); */
  });
}

export const sendToHomologador = (RutPrestador) => async dispatch => {
  //dispatch(IdSolicitudHom(0));
  const globalState = store.getState().global;
  const { prestacionesToHomologador, IdSolicitudForHomologador: IdSolicitud } = store.getState().grillaSolicitud;

  fetch(`${apiConfig.apiHomologador}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: globalState.token,
      //credentials: 'same-origin',
    },
    body: JSON.stringify({
      Origen: 'A/W',
      RutPrestador: RutPrestador,
      Prestacion: prestacionesToHomologador,
      token: globalState.token,
    }),
  }).then(res => res.json().then(async data => {
    //trace.information('sendToHomologador', data);
    dispatch(IdSolicitudHom(data.Solicitud.IdSolicitud));

    const IdSolicitudHomologador = [];
    let enCurso = 0;

    if (data.PresCurso.length) {
      dispatch(SetSolicitudesEnCurso(true));
      dispatch(nuevaSolicitud(null));
      enCurso = 1;
      /*for (const item of data.PresCurso) {
        IdSolicitudHomologador.push(item.IdSolicitud);
      }*/
      await fetch(`${apiConfig.apiUri}/v1/solicitudes/updateVigenciaSolicitud`, {
        method: 'POST',
        body: JSON.stringify({
          IdSolicitud: IdSolicitud,
          token: globalState.token,
        }),
      }).then(res => res.json().then(
        data => trace.information('updateVigenciaSolicitud ', data)
      )).catch(error => {
        trace.error('updateVigenciaSolicitud', error);
        dispatch(ErrorSnacktOpen(
          "Error al quitar la vigencia de la solicitud",
          error,
        ));
      })
    }

    if ((Object.keys(data.Solicitud).length && data.Solicitud.IdSolicitud) && enCurso === 0) {
      IdSolicitudHomologador.push(data.Solicitud.IdSolicitud);
      dispatch(PermiteReplicarSolicitud());
      dispatch(OpenSolicitudEnviada(true));
      dispatch(nuevaSolicitud(null));
      if (data.PresHomol.length === 0) {
        dispatch(ErrorSnacktOpen("Solicitud Enviada"));
      }
    }

    if (data.PresHomol.length && enCurso === 0) {
      let homologadas = data.PresHomol.length;
      let diferencia = prestacionesToHomologador.length - homologadas;
      //trace.error('updatePrestacionesHomologadas, prestaciones: ', data.PresHomol.length);
      for (let i = 0; i < data.PresHomol.length; i++) {
        data.PresHomol[i]["idSolicitud"] = IdSolicitud;
        data.PresHomol[i]["username"] = null;
      }

      //console.log("Homologadas: ", data.PresHomol)
      dispatch(prestacionesHomologadas(data.PresHomol));

      let final = 0;

      if (diferencia === 0) {
        final = 1;
      } else {
        final = 0;
      }

      await fetch(`${apiConfig.apiUri}/v1/solicitudes/updatePrestacionesHomologadas`, {
        method: 'POST',
        body: JSON.stringify({
          idSolicitud: IdSolicitud,
          prestacionesHomologadas: data.PresHomol,
          token: globalState.token,
          final: final,
        }),
      }).then(res => res.json().then(data => {
        //trace.information('updatePrestacionesHomologadas', data);
        dispatch(PermiteReplicarSolicitud());
        dispatch(OpenSolicitudEnviada(true));
        dispatch(nuevaSolicitud(null));
        if (homologadas === prestacionesToHomologador.length) {
          dispatch(ErrorSnacktOpen("Todos los Codigos ya se encuentran homologados en el Homologador."));
        } else if (homologadas > 1 && homologadas != prestacionesToHomologador.length) {
          if (diferencia != 1) {
            dispatch(ErrorSnacktOpen("Existen Códigos Homólogos para " + homologadas + " prestaciones en la solicitud, se crea solicitud en el Homologador para las " + (prestacionesToHomologador.length - homologadas) + " prestaciones restantes."));
          } else {
            dispatch(ErrorSnacktOpen("Existen Códigos Homólogos para " + homologadas + " prestaciones en la solicitud, se crea solicitud en el Homologador para la prestación restante."));
          }
        } else if (homologadas === 1 && homologadas != prestacionesToHomologador.length) {
          if (diferencia != 1) {
            dispatch(ErrorSnacktOpen("Existe Código Homólogo para " + homologadas + " prestación en la solicitud, se crea solicitud en el Homologador para las " + (prestacionesToHomologador.length - homologadas) + " prestaciones restantes."));
          } else {
            dispatch(ErrorSnacktOpen("Existen Códigos Homólogos para " + homologadas + " prestación en la solicitud, se crea solicitud en el Homologador para la prestación restante."));
          }
        }
      })).catch(error => {
        trace.error('updatePrestacionesHomologadas', error);
        dispatch(ErrorSnacktOpen(
          "Error al guardar Homologación de prestaciones:",
          error,
        ));
      })
    }

    if (IdSolicitudHomologador.length > 0) {
      fetch(`${apiConfig.apiUri}/v1/solicitudes/updateIdSolicitudHomologador`, {
        method: 'POST',
        body: JSON.stringify({
          IdSolicitud: IdSolicitud,
          IdSolicitudHomologador: IdSolicitudHomologador,
          token: globalState.token,
        }),
      }).then(res => res.json().then(
        data => trace.information('updateIdSolicitudHomologador', data)
      )).catch(error => {
        trace.error('updateIdSolicitudHomologador', error);
        dispatch(ErrorSnacktOpen(
          "Error al guardar identificador de Homologador:",
          error,
        ));
      });

      fetch(`${apiConfig.apiUri}/v1/solicitudes/enviarCorreoPrestNuevas`, {
        method: 'POST',
        body: JSON.stringify({
          idSolicitud: IdSolicitud,
          Isapre: globalState.isapre,
          token: globalState.token,
          usuarioMail: globalState.datosUsuario.mail,
          usuarioNombre: globalState.datosUsuario.nombre,
          RutUsuario: globalState.rutUsuario,
        }),
      }).then(res => res.json().then(
        data => trace.information('enviarCorreoPrestNuevas', data)
      )).catch(error => {
        trace.error('enviarCorreoPrestNuevas', error);
        dispatch(ErrorSnacktOpen(
          "Error al enviar correo de notificacion de la Solicitud",
          error,
        ));
      })
    }
  }),
    err => {
      trace.error('sendToHomologador', err);
      dispatch(ErrorSnacktOpen(
        "Error al enviar al Homologador:",
        err,
      ))
    }
  );
}

/* export const GetDetalleSolicitud = (idSolicitud) => (dispatch) => {
  // const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  // const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  // dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/GetDetalleSolicitud`, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        // Authorization: localStorage.getItem('id_token'),
      },
      credentials: "same-origin",
      body: JSON.stringify(params),
    })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        trace.information("GetDetalleSolicitud", json);
        dispatch(CargarDetalleSolicitud(json, idSolicitud));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud:",
        error.message === "Failed to fetch" ? "No se encontro método API" : error
      ));
    });
};
 */
